import get from 'lodash/get';
import jwtDecode from 'jwt-decode';
import {useEffect} from 'react';
import {useDispatch,useSelector} from 'react-redux';

import getToken from '../redux/selectors/getToken';
import {logout} from '../redux/reducers/auth';
import {start as startInactivityTracker} from '../redux/reducers/inactivity';

const useAutoSignout = (
  _logout = logout,
  _startInactivityTracker = startInactivityTracker
) => {
  const token = useSelector(getToken());
  const dispatch = useDispatch();
  // logout if the token is expired
  const exp = token ? get(jwtDecode(token), 'exp') : null;
  useEffect(() => {
    if (exp && Date.now() >= exp * 1000) dispatch(_logout());
  }, [exp, dispatch, _logout]);
  // logout if the user is inactive for a period of time
  useEffect(() => {
    if (token) dispatch(_startInactivityTracker());
  }, [token, dispatch, _startInactivityTracker]);
};

export default useAutoSignout;
